import { render } from "./CartPage.vue?vue&type=template&id=4ae6ca84&scoped=true"
import script from "@/assets/js/cart?vue&type=script&defer=true&lang=js&external"
export * from "@/assets/js/cart?vue&type=script&defer=true&lang=js&external"

import "@/assets/css/cart.css?vue&type=style&index=0&id=4ae6ca84&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae6ca84"]])

export default __exports__